import { createSelector } from "reselect";

import { getBillingDocuments } from "../root";
import { getInterestPreviewById } from "../interestPreview";
import {
  BusinessAggridDataPacket,
  selectBusinessesAggridDataById,
} from "./businesses";

export interface InterestPreviewAggridRow
  extends Partial<BusinessAggridDataPacket> {
  interestPreview: InterestPreviewData;
  billingDocument?: BillingDocument;
}

export const selectInterestPreviewAgGridData = createSelector(
  [getInterestPreviewById, getBillingDocuments, selectBusinessesAggridDataById],
  (
    interestPreviewById,
    billingDocuments,
    businessesAggridDataById,
  ): InterestPreviewAggridRow[] =>
    Object.values(interestPreviewById).map(interestPreview => ({
      ...businessesAggridDataById[interestPreview.businessId],
      interestPreview,
      billingDocument: billingDocuments[interestPreview.billingDocumentId],
    })),
);
